module.exports = __webpack_public_path__ + "fonts/HarmonyOS_Sans_Medium.1ec44b30.ttf";